<template>
  <div class="gh-members-row-wrapper">
    <v-row v-for="(row, rowIndex) in memberRow" class="gh-members-row" :key="rowIndex">
      <v-col v-for="(member, index) in row" :cols="12" :xl="6" :key="member.name">
        <div class="gh-member-card">
          <div class="gh-member-avatar">
            <img :src="`/images/`+ member.avatar" :alt="member.name" width="100%">
          </div>
          <div class="gh-member-profile">
            <h3 class="gh-member-name">{{ member.name }}</h3>
            <div v-if="screenWidth >= 768">
              <div class="gh-member-bio" v-html="member.bio"></div>
            </div>
            <div v-else>
              <div class="gh-member-bio" v-html="bio(member, index)"></div>
              <a class="gh-btn-read-more" @click="toggleReadMore(index)">
                <div class="gh-btn-read-more-text">{{ readMoreText(index) }}</div>
                <v-icon color="black">{{ readMore[index] ? 'remove' : 'add' }}</v-icon>
              </a>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-btn v-show="screenWidth < 768" block tile outlined color="black" @click="toggleViewAll" large>{{ viewAllText }}</v-btn>
  </div>
</template>

<script>
import { chunk } from 'lodash'
  export default {
    name: "MemberRow",

    props: {
      team: { type: Array, require: true }
    },

    data() {
      return {
        screenWidth: window.innerWidth,
        readMore: {0: false, 1: false},
        viewAll: false
      }
    },

    computed: {
      memberRow() {
        if(this.screenWidth >= 768 || this.viewAll) {
          return chunk(this.team, 2)
        } else {
          return chunk(this.team.slice(0,4), 2)
        }
      },

      viewAllText() {
        return this.viewAll ? 'VIEW LESS' : 'VIEW ALL'
      },
    },

    mounted () {
      window.addEventListener("resize", this.resize)
    },

    methods: {
      bio(member, index) {
        return this.readMore[index] ? member.bio : member.shortBio
      },

      readMoreText(index) {
        return this.readMore[index] ? 'READ LESS' : 'READ MORE'
      },

      toggleReadMore(index) {
        this.readMore[index] = !this.readMore[index]
      },

      toggleViewAll() {
        this.viewAll = !this.viewAll
      },

      resize () {
        this.screenWidth = window.innerWidth
      }
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.resize);
    }
  }
</script>

<style scoped lang="sass">
  .gh-btn-read-more
    display: flex
    justify-content: space-between
    margin-top: 1rem
    margin-bottom: 1rem
  .gh-btn-view-all

    display: block
    text-align: center
</style>
